export default "__VITE_ASSET__CydXtHp8__"